import { UIComponentViewImpl } from '../uicomponentview';
import { UIDataModel } from '../uicomponent';
import { ToolbarComponentProps, ToolbarComponentHandler, ToolbarComponentState } from './toolbarcomponent';
import { ToolbarCSSStyle } from './toolbarcss';
import * as React from 'react';
import { Strings } from '../../../utils/resources/strings';
import { CategoryDto } from '../../../core/dto/categories/categorydto';
import { CategoriesCardComponent } from '../../components/home/categories/viewmodel/categoriescard/categoriescardcomponent';
import { LanguageConst } from '../../../utils/resources/languageconst';
import { HeaderComponent } from '../header/headercomponent';
// import { LanguageComponent } from '../header/language/languagecomponent';
import { ImageButtonComponent } from '../imagebutton/imagebuttoncomponent';
import { ImageButtonCSSStyleImpl } from '../imagebutton/imagebuttoncss';
import { LanguageComponent } from '../header/language/languagecomponent';

export class ToolbarViewImpl extends UIComponentViewImpl<UIDataModel>
{
    bindHandlers()
    {
        this.onLogoClicked = this.onLogoClicked.bind(this);
        this.onSignInClicked = this.onSignInClicked.bind(this);
        this.onDoItYouselfClicked = this.onDoItYouselfClicked.bind(this);
        this.onCategorySelected = this.onCategorySelected.bind(this);
        this.showTunesOption = this.showTunesOption.bind(this);
        this.hideTunesOption = this.hideTunesOption.bind(this);
        this.onFaqClicked = this.onFaqClicked.bind(this);
    }

    draw(props: ToolbarComponentProps, state: ToolbarComponentState, cssStyle: ToolbarCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);
        
       return (
           <>
             <div style={cssStyle.getToolbarContainerCSSStyle()}>
                    {/* <img onClick={this.onLogoClicked} src={props.context.getResources().getImage("mpt_logo.svg")} style={cssStyle.getIconCSSStyle()} /> */}
                    <div style={cssStyle.getTitleDivCSSStyle()} onClick={this.showTunesOption}>
                        <label style={cssStyle.getTitleCSSStyle(false)}>{props.context.getResources().getString(Strings.tunes)}</label>
                        <img  style={{width:'9px', cursor: "pointer",marginLeft:this.getContext().getUserContext().getLanguage() === LanguageConst.FRENCH?'7px':"7px", marginRight:this.getContext().getUserContext().getLanguage() === LanguageConst.FRENCH?"0px":"0px",height:'5px'}} src={this.getContext().getResources().getImage("down_arrow_gray.svg")}/>
                    </div>
                    {
                            this.createHeaderComponent()
                        }
                    {/* <div style={cssStyle.getTitleDivCSSStyle()} onClick={this.onSalathiClicked}>
                        <label style={cssStyle.getTitleCSSStyle()}>{props.context.getResources().getString(Strings.salati)}</label>
                    </div> */}
                    {/* <div style={cssStyle.getTitle2DivCSSStyle()} onClick={this.onDoItYouselfClicked}>
                        <label style={cssStyle.geDoItYouselfCSSStyle()}>{props.context.getResources().getString(Strings.doityourself)}</label>
                    </div> */}

                    <div style={{height: "60px", display: "flex"}}>
                        <LanguageComponent onLanguageChange={(language: LanguageConst) => {(this.getUIComponentHandler() as ToolbarComponentHandler).onLanguageChange(language);}} context={props.context}/>
                    </div>
                     {
                     !props.context.getUserContext().getIsLoggedIn() && 
                      <>
                         {/* <div style={{marginLeft:this.getContext().getUserContext().getLanguage() === LanguageConst.FRENCH?'auto':"15px",marginRight:this.getContext().getUserContext().getLanguage() === LanguageConst.FRENCH?'15px':"auto"}}>
                            <label onClick={this.onSignInClicked} style={cssStyle.getSignUpCSSStyle()}>{props.context.getResources().getString(Strings.signin)}</label>
                         </div> */}
                         <div onClick={this.onSignInClicked} style={cssStyle.getButtonDivCSSStyle()}>
                            <ImageButtonComponent onClick={this.onSignInClicked} style={new ImageButtonCSSStyleImpl(props.context)} context={props.context} label={"Login"}/>

                        </div>
                        </>
                    }
             </div>
             {
                 state.isTunesSelected &&
                <div onMouseLeave={this.hideTunesOption} style={cssStyle.getTunesDropDownSSStyle()}>
                {
                    state.categories.map((t: CategoryDto, position: number) =>
                    {
                        return <CategoriesCardComponent key={position} onSelected={this.onCategorySelected} context={this.getContext()} categoryDto={t}  position={position}/>;
                    })
                }
                </div>}
               
             </>
       );
    }

    protected createHeaderComponent(): JSX.Element | boolean
    {
        return <HeaderComponent onFaqClicked={this.onFaqClicked} context={this.getUIProps().context}/>;
    }

    protected onFaqClicked()
    {
        (this.getUIProps() as ToolbarComponentProps).onFaqClicked();
    }
    

    onCategorySelected(categoryDto: CategoryDto): void
    {
        (this.getUIComponentHandler() as ToolbarComponentHandler).deselectAll();
        (this.getUIComponentHandler() as ToolbarComponentHandler).onCategoriesSelected(categoryDto.getTitle());
    }

    private showTunesOption() 
    {
        (this.getUIComponentHandler() as ToolbarComponentHandler).onTunesSelected(true);
    }

  
    private hideTunesOption()
    {
        (this.getUIComponentHandler() as ToolbarComponentHandler).onTunesSelected(false);
    }

    private onLogoClicked()
    {
        (this.getUIProps() as ToolbarComponentProps).onLogoClicked();
    }

    private onSignInClicked()
    {
        (this.getUIComponentHandler() as ToolbarComponentHandler).onSignInClicked();
    }

    private onDoItYouselfClicked()
    {
        (this.getUIProps() as ToolbarComponentProps).onDoItYourselfClicked();
    }

   

    // private onSalathiClicked()
    // {
    //     (this.getUIProps() as ToolbarComponentProps).onSalathiClicked();
    // }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/toolbar/toolbarview.tsx